import { render, staticRenderFns } from "./alipayWithholdDialogNew.vue?vue&type=template&id=1d3406c8&scoped=true"
import script from "./alipayWithholdDialogNew.vue?vue&type=script&setup=true&lang=js"
export * from "./alipayWithholdDialogNew.vue?vue&type=script&setup=true&lang=js"
import style0 from "./alipayWithholdDialogNew.vue?vue&type=style&index=0&id=1d3406c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3406c8",
  null
  
)

export default component.exports